import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export default function useDeleteCustomSkill(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (skillId: string) =>
      api.delete(`/admin/companies/${companyId}/custom-skills/${skillId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['admin', 'companies', companyId, 'custom-skills'],
      });
    },
  });
}
